module.exports = __webpack_public_path__ + "static/media/marker-icon.2ac0f20e.png";